import { Typography, Hidden } from '@ori-ui/mui';
import { Team, TestIdProvider } from '@ori/testid-generator';
import type { FC } from 'react';

import { FollowUsRoot } from '../../components/FollowUs/styles';
import { UnifiedSkeleton } from '../../components/styles';
import { APP_NAME } from '../../constants-generated';
import { BottomContent, FourthColumn, Highlight, HighlightGrid, Root } from '../FooterContent/styles';
import { LinkColumn, MobileAppsColumn } from './components';
import { MobileLinkColumn } from './components/LinkColumn/styles';
import { CopyrightRoot, LinksRoot, SubscribeBannerRoot } from './styles';

/**
 * Footer app skeleton for when the footer is no longer served via SSR but rendered only via CSR
 */
export const FooterAppSkeleton: FC = () => (
  <TestIdProvider
    team={Team.Presentation}
    project={APP_NAME}
  >
    <Root>
      <SubscribeBannerRoot>
        <UnifiedSkeleton
          height={27}
          width={400}
        />
      </SubscribeBannerRoot>
      <Highlight>
        <HighlightGrid>
          <LinksRoot>
            <Hidden smUp>
              <MobileLinkColumn />
              <MobileLinkColumn />
              <MobileLinkColumn />
            </Hidden>
            <Hidden smDown>
              <LinkColumn />
              <LinkColumn />
              <LinkColumn />
            </Hidden>
          </LinksRoot>
          <FourthColumn>
            <MobileAppsColumn />
          </FourthColumn>
        </HighlightGrid>
      </Highlight>
      <BottomContent>
        <FollowUsRoot>
          <Typography variant="h6">
            <UnifiedSkeleton width={85} />
          </Typography>
          <UnifiedSkeleton
            width={200}
            height={34}
          />
        </FollowUsRoot>
        <Hidden mdUp>
          <MobileAppsColumn />
        </Hidden>
        <CopyrightRoot>
          <UnifiedSkeleton
            width={340}
            height={40}
          />
        </CopyrightRoot>
      </BottomContent>
    </Root>
  </TestIdProvider>
);
